module.exports = __webpack_public_path__ + "img/icon-shipping-box.7277fb16.svg";